import React from 'react';
import styled from 'styled-components';
import { DocumentGroup } from 'types/documentGroup';
import { JobOutput } from 'types';
import JobList from '../processing-jobs/JobList';
import { JobCrossMatch } from '../../../types/proccesingJobs';

interface OwnProps {
  group: DocumentGroup;
  documents: JobOutput[];
  jobCrossMatches: JobCrossMatch[];
  remove: (groupId: string, documentId: string) => void;
}

const GroupListItems = styled.div`
  width: 100%;
`;

const GroupListItemBody = ({ group, documents, jobCrossMatches, remove }: OwnProps) => {
  const handleRemove = (_processingJobId: string, documentId: string | undefined) => {
    if (documentId) {
      remove(group.id, documentId);
    }
  };

  return (
    <GroupListItems>
      <JobList
        jobFiles={documents}
        jobCrossMatches={jobCrossMatches}
        remove={handleRemove}
        refresh={undefined}
      />
    </GroupListItems>
  );
};

export default GroupListItemBody;
